/**
 * Dropdown (PopoverContent) styles for `forms/ComboBox.vue` (`variant` prop).
 * Kept in a plain module so wrappers (e.g. MultiSwitcher) can reuse the type.
 *
 * - `default`: plain popover.
 * - `framed`: the search list sits as a card inside a padded, light-grey,
 *   rounded frame (same look as the Appbar SearchComponent popover).
 */
export const comboBoxContentVariants = {
  default: "",
  framed: "rounded-xl bg-neutral-100 p-2",
} as const;

export type ComboBoxVariant = keyof typeof comboBoxContentVariants;
